import { CommonModule } from '@angular/common';
import { Component, OnInit, ChangeDetectionStrategy, Input, NgModule } from '@angular/core';
import { TaskType } from '@fitness-force/enum';
import { ButtonModule } from 'primeng/button';
import { RippleModule } from 'primeng/ripple';
import { StyleClassModule } from 'primeng/styleclass';
import { BehaviorSubject } from 'rxjs';

@Component({
  selector: 'task-type-report',
  templateUrl: './task-type-report.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [    CommonModule,
    ButtonModule,
    RippleModule,
    StyleClassModule]
})
export class TaskTypeReportComponent  {
  @Input() columnData = new BehaviorSubject(null)
  @Input() additionData = new BehaviorSubject(null)
  task!:TaskType

  getEnumKeyByEnumValue( enumValue: number | string): string {
    let keys = Object.keys(TaskType).filter((x:any) => TaskType[x] == enumValue);
    return keys.length > 0 ? keys[0] : '';
  }
}